module.exports = __webpack_public_path__ + "static/masking_data-83a6b01a89e999f4c9e2868c3c8470de.png";